import React from 'react';
import { Form } from 'semantic-ui-react';
import { AllClaimStates } from '../../queries/AllClaimStates'
import { compose, graphql } from 'react-apollo';

class StatesDropdown extends React.Component {
  state = {}

  render = () => {
    const statesOptions = (this.props.data && this.props.data.allClaimStates &&
      this.props.data.allClaimStates.map((a, i) => (
        {
          key: i,
          value: a,
          text: a
        })
      )) || []
    return (
      <Form.Dropdown
        fluid
        selection
        search
        multiple={this.props.multiple}
        disabled={this.props.value !== null}
        options={statesOptions}
        name={this.props.name}
        label={this.props.label}
        placeholder={this.props.placeholder}
        value={this.props.value}
        onChange={this.props.onChange}
        onSearchChange={this.handleChange}
        onBlur={this.props.onBlur}
        loading={this.state.loading}
      />
    )
  }
}

const StatesDropdownWithData = compose(
  graphql(AllClaimStates, { options: (props) => ({ fetchPolicy: 'cache-first' }) })
)(StatesDropdown)

export default StatesDropdownWithData;








// WEBPACK FOOTER //
// ./src/component/dropdowns/StatesDropdown.js